import Head from 'next/head'
import Script from 'next/script'
import Image from 'next/image'
import { s3Static } from '../../../utils/constants'
import { getArticleDateTime } from '../../../utils/article-date-time'
import { BlogsList } from '../../../components/blogs/BlogList'
import { blogsMaster } from '../../../utils/sg-blogs-data'
import { getRequestJSON } from '../../../api/index/location-api'
import Link from 'next/link'
import { Carousel } from 'react-responsive-carousel'
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { FaBroom, FaHandsHelping, FaHeadset, FaRobot, FaRocket, FaStar, FaUserShield, FaWhatsapp } from 'react-icons/fa'
import { useRouter } from 'next/router'
import { useCallback, useEffect, useRef, useState } from 'react'
import { RequestProvider } from '../../../context/RequestContext'
import { Services } from '../../../components/index/service/Services'
import { AnimatePresence, motion } from 'framer-motion'
import { getWpNewHouseKeeping, setWpNewHouseKeeping } from '../../../service/wp-blogs-store'
import { getWpNewPostsByCategory } from '../../../lib/service'
import { PartTimeHelperBooking } from '../../../components/index/service-category/domestic-service/PartTimeHelperBooking'
import { getAppSettings } from '../../../api/app-setting/app-setting'
import { SystemError } from '../../../components/error/SystemError'
import { openModal } from '../../../service/modal-service'
import { helperCostCalculation } from '../../../js/part-time-helper-cost'
import { helperTestimonials } from '../../../data/CustomerReviewData'
import LazyYouTubeEmbed from '@/commons/LazyYouTubeEmbed'

export async function getStaticProps() {
    const countryCd = "sg"
    const countryName = "Singapore"
    
    const allRequestCategorySettings = await getRequestJSON(countryName)

    const requestCategorySettings = allRequestCategorySettings.filter(category => category.requestType === "Domestic Services")
    
    const lat = 1.3521
    const lng = 103.8198

    const { modifiedDate, month, year } = getArticleDateTime()
    const houseKeepingBlogs = blogsMaster['house-keeping'].blogArray;
    const wpNewPosts = getWpNewHouseKeeping().length > 0 ?  getWpNewHouseKeeping() : await getWpNewPostsByCategory(6, "house-keeping");
    setWpNewHouseKeeping(wpNewPosts)

    const currencyCd = "SGD"

    let helperService = []
    let babySitterService = []
    let elderlyCareService = []
    let cookingAssistanceService = []  
    
    helperCostCalculation(currencyCd, helperService, babySitterService, elderlyCareService, cookingAssistanceService)

    return {
        props: {
            requestCategorySettings,
            modifiedDate,
            month,
            year,
            houseKeepingBlogs,
            currencyCd,
            helperService,
            elderlyCareService,
            helperTestimonials,
            wpNewPosts,
            countryName
        },
        // Next.js will attempt to re-generate the page:
        // - When a request comes in
        // - At most once every 10 seconds
        revalidate: 259200, // In seconds
    }
}
export default function Home(props) {
    const router = useRouter()
    const modifiedDate = props.modifiedDate
    const month = props.month
    const year = props.year
    const houseKeepingBlogs = props.houseKeepingBlogs
    const wpNewPosts = props.wpNewPosts
    const requestCategorySettings = props.requestCategorySettings;
    const testimonials = props.helperTestimonials
    const maxRating = [1, 2, 3, 4, 5]
    const requestType = 'Domestic Services'
    const countryName = props.countryName
    const currencyCd = props.currencyCd
    const helperService = props.helperService
    const elderlyCareService = props.elderlyCareService

    const [ requestForm, setRequestForm ] = useState(router.query.requestForm)
    const [ waInd, setWaInd ] = useState(false)
    const [ isQuickBook, setIsQuickBook ] = useState(false)

    const [ isSystemError, setIsSystemError ] = useState(false);
    const [ errorContent, setErrorContent ]  = useState({'header': "", 'body': ""})

    useEffect(() => {
        setRequestForm(router.query.requestForm)
    }, [router.query.requestForm])

    const videoRef = useRef();

    useEffect(() => {    
        if(requestForm) return
        videoRef.current.play()
    }, [requestForm])

    const fetchAppSetting = useCallback(async() => {
        try {
            const appSettings = await getAppSettings(countryName)
            setWaInd(appSettings.waBusinessInd)
        } catch (error) {
            console.log(error);
        }
    }, [countryName])

    useEffect(() => {
        if(!countryName) return

        fetchAppSetting()
    }, [countryName, fetchAppSetting])

    const showJobScope = () =>{
        setErrorContent({'header': "Service Scope", 'body': "Sweeping/vacuuming, dusting, mopping and maintaining general home cleanliness.\n\nBathroom - Bathroom and toilet cleaning.\n\nBedroom - Bed sheet changing.\n\nKitchen - Dishwashing, countertop wiping, hood cleaning & stove cleaning.\n\nWindows - Accessible indoor side of window cleaning.\n\nFan - Wiping of easily accessible standing or table fan. Ceiling fan is out of scope.\n\n* THE HELPER WILL NOT BE CARRYING ANY EQUIPMENT.\n* NOT IN SCOPE - Move-out, Post-renovation or Spring Cleaning.\n* This service is for residential premises only.\n\n"});
        openModal(setIsSystemError)
    }

  return (
    <>
      <Head>
        <title>Part Time Helper Service Scope Of Work in Singapore</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="description" content="Explore the flexibility and convenience of our part-time maids for cleaning service, tailored to meet your specific needs. Learn more about the service offered by our part-time cleaners.."/>
        <meta name="keywords" content="House Rental, Insurance Plan, Personal Trainer, Maid Service, Handyman Service, Aircon Service, Savings Plan, Food Catering, Interior Design, Wedding Planner, Event Planner"/>
        <meta name="author" content="StringsSG"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:url"   content="https://www.stringssg.com/sg/part-time-cleaner-singapore/job-scope-of-part-time-cleaner-service" />
        <meta property="og:type"   content="article" />
        <meta property="og:title"    content={`Part Time Helper Service Scope Of Work in Singapore`}/>
        <meta property="og:description" content="Explore the flexibility and convenience of our part-time maids for cleaning service, tailored to meet your specific needs. Learn more about the service offered by our part-time cleaners.." />
        <meta property="article:publisher" content="https://www.facebook.com/StringsSG/" />
        <meta property="article:published_time" content="2025-01-29T07:30:46+00:00" />
        <meta property="article:modified_time" content={modifiedDate} />
        <meta property="og:image"  content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/part-time-helper/part-time-helper-posing.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/part-time-helper/part-time-helper-posing.jpg" />
        <meta name="twitter:site" content="@stringssg"/> 
        <meta name="twitter:url" content="https://www.stringssg.com/sg/part-time-cleaner-singapore/job-scope-of-part-time-cleaner-service"/>
        <meta name="twitter:title" content={`Part Time Helper Service Scope Of Work in Singapore`}/> 
        <meta name="twitter:description" content="Explore the flexibility and convenience of our part-time maids for cleaning service, tailored to meet your specific needs. Learn more about the service offered by our part-time cleaners.."/>
        <link rel="icon" href="/favicon.ico" />
        <script type="application/ld+json"
          dangerouslySetInnerHTML={{ __html:
            `{"@context":"https://schema.org","@graph":[{"@context":"https://schema.org/","@type":"BlogPosting","mainEntityOfPage":{"@type":"WebPage","@id":"https://www.stringssg.com/sg/part-time-cleaner-singapore/job-scope-of-part-time-cleaner-service"},"headline":"Part Time Helper Service Scope Of Work in Singapore","description":"Explore the flexibility and convenience of our part-time maids for cleaning service, tailored to meet your specific needs. Learn more about the service offered by our part-time cleaners..","image":["https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/part-time-helper/part-time-helper-posing.jpg"],"author":{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG","url":"https://www.stringssg.com/"},"publisher":{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG","url":"https://www.stringssg.com/","logo":{"@type":"ImageObject","url":"https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/logo.png"}},"datePublished":"2025-01-29T07:30:46+00:00","dateModified":"${modifiedDate}"},{"@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"item":{"@type":"WebPage","@id":"https://www.stringssg.com/","name":"Home","url":"https://www.stringssg.com/"}},{"@type":"ListItem","position":2,"item":{"@type":"WebPage","@id":"https://www.stringssg.com/sg/part-time-cleaner-singapore","name":"Part Time Cleaner Singapore","url":"https://www.stringssg.com/sg/part-time-cleaner-singapore"}},{"@type":"ListItem","position":3,"item":{"@type":"WebPage","@id":"https://www.stringssg.com/sg/part-time-cleaner-singapore/job-scope-of-part-time-cleaner-service","name":"Job Scope Of Part Time Cleaner Service","url":"https://www.stringssg.com/sg/part-time-cleaner-singapore/job-scope-of-part-time-cleaner-service"}}]}]}`
          }}
        />
        <link rel="canonical" href="https://www.stringssg.com/sg/part-time-cleaner-singapore/job-scope-of-part-time-cleaner-service"/>
        </Head>
        <section id="helper-job-scope-singapore" className='relative'>
            <div className="-mt-14 relative w-full aspect-video sm:aspect-16/6 overflow-hidden">
                {/* Mobile Video */}
                <video
                    ref={videoRef}
                    className="absolute inset-0 w-full h-full object-cover sm:hidden"
                    poster={s3Static + "blog/living/part-time-helper/housekeeping-1920-1080.jpg"}
                    title="Part-time helper Singapore"
                    muted
                    loop
                    playsInline
                    preload="metadata"
                >
                    <source src="/video/part-time-helper-web.mp4" />
                    <source src="/video/part-time-helper-web.mov" />
                </video>

                {/* Desktop Image */}
                <Image
                    src={s3Static + "part-time-helper/part-time-helper-posing.jpg"}
                    fill
                    className="hidden sm:block object-cover"
                    alt="Part-time helper Singapore"
                    priority={false}
                    quality={100}
                    sizes="100vw"
                />
            </div>
            <RequestProvider>
                <div className="helper-banner -mt-14 relative overflow-hidden transition-height duration-200">                
                    <div id="campaign" className='absolute top-1/2 -translate-y-1/2 w-full'>
                        <PartTimeHelperBooking requestCategorySettings={requestCategorySettings} setRequestForm={setRequestForm} helperService={helperService} elderlyCareService={elderlyCareService}
                            setIsQuickBook={setIsQuickBook} countryName={countryName} currencyCd={currencyCd} helperType="Cleaner" showJobScope={showJobScope}/>
                    </div>
                </div> 
                {requestForm &&
                    <Services requestType={requestType} requestCategorySettings={requestCategorySettings} setRequestForm={setRequestForm} isQuickBook={isQuickBook} asSheet/>
                }      
            </RequestProvider>  
        </section>
        <section className='max-w-4xl mx-auto py-10 px-2 space-y-8'>
            <h1 className='text-3xl md:text-4xl font-semibold text-center'>Part Time Helper Service Scope Of Work in Singapore</h1>
            <div className='leading-8 space-y-3'>
                <p>                        
                    Singapore being one of the busiest city in the world, makes it difficult for residents to find time to carry out regular housekeeping activities.
                    This is where part-time cleaners play an important work to keep your kitchen, toilet and floor clean, so that you can focus on more important things in your life.                        
                </p>
                <p>
                    Let us deep dive into how part-time cleaners can help us what is included in their job scope.
                </p>
            </div>                
        </section>
        <section className='max-w-5xl mx-auto py-10'>
            <div className='grid grid-cols-1 md:grid-cols-2 gap-10 px-2'>
                <div className='border rounded-3xl overflow-hidden'>                        
                    <div className="space-y-5 whitespace-normal">
                        <div className='h-80 sm:h-96 relative'>   
                            <Image
                                src={s3Static + "blog/living/part-time-helper/part-time-cleaner-with-bucket.jpg"}
                                fill
                                sizes="(max-width: 768px) 100vw, 33vw"
                                style={{objectFit: 'cover', objectPosition: 'bottom'}}
                                placeholder='blur'
                                blurDataURL={s3Static + "placeholder.png"}
                                alt='General Home Cleaning - StringsSG'
                            />
                        </div>  
                        <div className="space-y-4 py-5">                            
                            <h2 className='text-center text-xl uppercase'>
                                <strong>General Cleaning</strong>
                            </h2>                           
                            <ul className='space-y-2 leading-7 pl-6 pr-2 list-disc text-sm'>
                                <li>
                                    Thorough dusting of surfaces, furniture, shelves, and electronics for a clean, fresh ambiance.
                                </li>
                                <li>
                                    Comprehensive sweeping or vacuuming of floors, carpets, and rugs for improved air quality.
                                </li>
                                <li>
                                    Meticulous mopping of hard floors, leaving them sparkling clean.
                                </li>
                                <li>
                                    Detailed surface wiping of tabletops & countertops for a sanitized, presentable space.
                                </li>
                            </ul>
                            <div className='py-4 text-center'>
                                <Link className='px-5 py-4 rounded-3xl text-white bg-linear-to-tr from-orange-600 to-amber-400 hover:from-amber-400 hover:to-orange-600' 
                                href="/sg/part-time-cleaner-singapore/the-role-of-part-time-cleaners-in-general-cleaning" prefetch={false}>
                                    <strong>Learn More</strong>
                                </Link>
                            </div>
                        </div>                        
                    </div>
                </div>
                <div className='border rounded-3xl overflow-hidden'>                        
                    <div className="space-y-5 whitespace-normal">
                        <div className='h-80 sm:h-96 relative'>   
                            <Image
                                src={s3Static + "part-time-helper/part-time-cleaner-cleaning-kitchen-countertop.jpg"}
                                fill
                                sizes="(max-width: 768px) 100vw, 33vw"
                                style={{objectFit: 'cover', objectPosition: 'center'}}
                                placeholder='blur'
                                blurDataURL={s3Static + "placeholder.png"}
                                alt='Maid cleaning kitchen'
                            /> 
                        </div>  
                        <div className="space-y-4 py-5">                            
                            <h2 className='text-center text-xl uppercase'>
                                <strong>Kitchen Cleaning</strong>
                            </h2>   
                            <ul className='space-y-2 leading-7 pl-6 pr-2 list-disc text-sm'>
                                <li>
                                    Thorough cleaning and disinfection of kitchen countertops to eliminate germs, bacteria, and food residue.
                                </li>
                                <li>
                                    Wiping down kitchen appliances — microwaves, stoves, ovens, and refrigerators—to remove grease, stains, and spills.
                                </li>
                                <li>
                                    Handwashing or running the dishwasher to clean and dry dishes, maintaining a neat and orderly kitchen.
                                </li>
                            </ul>
                            <div className='py-4 text-center'>
                                <Link className='px-5 py-4 rounded-3xl text-white bg-linear-to-tr from-orange-600 to-amber-400 hover:from-amber-400 hover:to-orange-600' href="/sg/part-time-cleaner-singapore/affordable-part-time-cleaners-for-kitchen-cleaning-at-20-hr" prefetch={false}>
                                    <strong>Learn More</strong>
                                </Link>
                            </div>
                        </div>                         
                    </div>
                </div>
                <div className='border rounded-3xl overflow-hidden'>                        
                    <div className="space-y-5 whitespace-normal">
                        <div className='h-80 sm:h-96 relative'>   
                            <Image
                                src={s3Static + "blog/living/part-time-helper/part-time-helper-cleaning-toilet.jpeg"}
                                fill
                                sizes="(max-width: 768px) 100vw, 33vw"
                                style={{objectFit: 'cover', objectPosition: 'center'}}
                                placeholder='blur'
                                blurDataURL={s3Static + "placeholder.png"}
                                alt='Helper cleaning toilet - StringsSG'
                            />
                        </div>  
                        <div className="space-y-4 py-5">                            
                            <h2 className='text-center text-xl uppercase'>
                                <strong>Bathroom Cleaning</strong>
                            </h2>                             
                            <ul className='space-y-2 leading-7 pl-6 pr-2 list-disc text-sm'>
                                <li>
                                    Disinfecting and cleaning bathroom surfaces including sinks, countertops, and mirrors
                                </li>
                                <li>
                                    Cleaning and disinfecting fixtures such as faucets, showerheads, and toilet bowls 
                                </li>
                                <li>
                                    Cleaning bathroom fixtures—faucets, showerheads, and toilet bowls to ensure a clean and fresh bathroom space.
                                </li>
                            </ul>
                            <div className='py-4 text-center'>
                                <Link className='px-5 py-4 rounded-3xl text-white bg-linear-to-tr from-orange-600 to-amber-400 hover:from-amber-400 hover:to-orange-600' 
                                href="/sg/part-time-cleaner-singapore/affordable-part-time-cleaner-for-bathroom-cleaning" prefetch={false}>
                                    <strong>Learn More</strong>
                                </Link>
                            </div>
                        </div>                        
                    </div>
                </div>
                <div className='border rounded-3xl overflow-hidden'>                        
                    <div className="space-y-5 whitespace-normal">
                        <div className='h-80 sm:h-96 relative'>   
                            <Image
                                src={s3Static + "part-time-helper/chinese-helper-makin-bed.jpg"}
                                fill
                                sizes="(max-width: 768px) 100vw, 33vw"
                                style={{objectFit: 'cover', objectPosition: 'center'}}
                                placeholder='blur'
                                blurDataURL={s3Static + "placeholder.png"}
                                alt='Helper making bed - StringsSG'
                            />
                        </div>  
                        <div className="space-y-4 py-5">                            
                            <h2 className='text-center text-xl uppercase'>
                                <strong>Other Services</strong>
                            </h2>                            
                            <ul className='space-y-2 leading-7 pl-6 pr-2 list-disc text-sm'>
                                <li>
                                    Wiping of interior side of easily accessible windows can be performed by the maid.
                                </li>
                                <li>
                                    The helpers can help to change the bedsheets.
                                </li>
                                <li>
                                    Wiping of easily accessible standing or table fan. Ceiling fan is out of scope.
                                </li>
                                <li>
                                    Most of our helpers can help with ironing and folding of clothes.
                                </li>
                            </ul>
                        </div>                        
                    </div>
                </div>
            </div>              
            <h3 className='text-center font-bold text-lg text-gray-500 pt-10 px-2'>Illustration video on what is included in part-time cleaning service in Singapore</h3>
            <LazyYouTubeEmbed videoId="JmlMQDN_V3s" title="Part-time cleaning service in Singapore" />
        </section>
        <section className="bg-linear-to-br from-gray-50 to-gray-100 py-20 px-4">
            <div className="max-w-6xl mx-auto">
                <h2 className="text-2xl md:text-3xl font-bold text-center uppercase mb-16">
                    Why Choose StringsSG?
                </h2>
                <div className="grid md:grid-cols-2 gap-10">
                    <div className="space-y-10">
                        <div className="flex items-center space-x-4">
                        <FaUserShield className="text-5xl text-amber-400 shrink-0 mt-1" />
                        <div>
                            <h3 className="text-xl font-semibold">100% Legal & Trusted Helpers</h3>
                            <p className="leading-relaxed">
                            Experience peace of mind with our <strong>fully legal and vetted part-time helpers</strong> who meet all MOM compliance standards.
                            </p>
                        </div>
                    </div>
    
                    <div className="flex items-center space-x-4">
                        <FaRobot className="text-5xl text-amber-400 shrink-0 mt-1" />
                        <div>
                            <h3 className="text-xl font-semibold">Smart Pricing with AI</h3>
                            <p className="leading-relaxed">
                            Get <strong>affordable, instant quotes</strong> using our AI-driven pricing engine — no guesswork, no overcharging.
                            </p>
                        </div>
                    </div>
    
                    <div className="flex items-center space-x-4">
                        <FaHandsHelping className="text-5xl text-amber-400 shrink-0 mt-1" />
                        <div>
                            <h3 className="text-xl font-semibold">Experienced, Trained Maids</h3>
                            <p className="leading-relaxed">
                            Our maids are <strong>well-trained and experienced</strong> in domestic cleaning, ensuring consistently high service standards.
                            </p>
                        </div>
                    </div>
                </div>    
                <div className="space-y-10">
                    <div className="flex items-center space-x-4">
                    <FaBroom className="text-5xl text-amber-400 shrink-0 mt-1" />
                    <div>
                        <h3 className="text-xl font-semibold">Comprehensive Cleaning Tasks</h3>
                        <p className="leading-relaxed">
                        From <strong>mopping, dusting, ironing, toilet scrubbing to kitchen cleaning</strong> — we’ve got your household covered.
                        </p>
                    </div>
                    </div>

                    <div className="flex items-center space-x-4">
                    <FaRocket className="text-5xl text-amber-400 shrink-0 mt-1" />
                    <div>
                        <h3 className="text-xl font-semibold">Instant Booking, No Wait</h3>
                        <p className="leading-relaxed">
                        Book your helper in <strong>under 2 minutes</strong> with our seamless platform — skip the calls, skip the hassle.
                        </p>
                    </div>
                    </div>

                    <div className="flex items-center space-x-4">
                    <FaHeadset className="text-5xl text-amber-400 shrink-0 mt-1" />
                    <div>
                        <h3 className="text-xl font-semibold">Responsive Customer Support</h3>
                        <p className="leading-relaxed">
                        Need help? Our <strong>in-app live chat</strong> connects you instantly to a support rep or your assigned service team.
                        </p>
                    </div>
                    </div>
                </div>
                </div>
            </div>
        </section>
        <div className='max-w-5xl mx-auto text-center py-10 relative'>
            <div className='relative w-full h-120'>
                <Image
                    src={s3Static + "blog/living/part-time-helper/cleaner-with-toilet-cleaning-bucket.jpg"}
                    fill
                    style={{objectFit: 'cover', objectPosition: 'right'}} 
                    placeholder='blur'
                    blurDataURL={s3Static + "placeholder.png"}
                    alt='Domestic helper service Singapore - StringsSG'
                />     
            </div> 
            <div className='absolute flex items-center text-white top-0 bottom-0 left-0 right-0 w-fit mx-auto rounded-3xl'>
                <Link href="/sg/part-time-cleaner-singapore" prefetch={false} className='p-4 rounded-lg bg-black/60 text-xl md:text-2xl'>
                    Book Part Time Cleaner
                </Link>       
            </div>  
        </div>     
        <div className='fixed bottom-2 w-full text-center z-10 flex justify-center space-x-5'>
            <button type="button" className='text-white py-2 px-4 rounded-full bg-linear-to-tr from-amber-700 to-amber-400 block font-bold ' onClick={() => openRequestForm()}>
                Book Now
            </button>
            <a href={waInd ? "https://wa.me/6593512695" : "https://wa.me/6588491419" } target="_blank" rel="noreferrer" className='flex items-center text-white py-2 px-4 rounded-full bg-linear-to-tl from-green-700 to-green-500 font-bold space-x-1'>
                <div>Chat</div>
                <FaWhatsapp className='text-2xl'/>
            </a>
        </div>
        <BlogsList blogs={houseKeepingBlogs} wpPosts={[]} wpNewPosts={wpNewPosts}/>
        <AnimatePresence>
            {isSystemError && <SystemError errorContent={errorContent} setIsSystemError={setIsSystemError}/>}
        </AnimatePresence>
        <Script 
            id="google-tagmanager-new"
            src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
            strategy="lazyOnload"
            onLoad={() => {              
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
            
                gtag('config', 'G-QD1HGGHDYJ');
            }} 
        />
        <Script id="facebook-tracking" strategy="lazyOnload">
            {`!function(f,b,e,v,n,t,s)
                {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                n.queue=[];t=b.createElement(e);t.async=!0;
                t.src=v;s=b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t,s)}(window, document,'script',
                'https://connect.facebook.net/en_US/fbevents.js');
                fbq('init', '128634041116395');
                fbq('track', 'PageView');`}
        </Script>
    </>
  )
}